/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 
define([
  "backbone",
  "utils/events",
  "underscore"
], function(
  Backbone,
  Events,
  _
) {

  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  return Backbone.Collection.extend(_.extend({}, Events, {

    initialize: function (models, options) {
      this.delegate = options.delegate;
      this._filter = options.filter;

      this.listenTo(this.delegate, "add", this._update);
      this.listenTo(this.delegate, "remove", this._update);
      this.listenTo(this.delegate, "reset", this._update);
      this.proxyAllEvents(this.delegate, /^(add|remove|reset)$/);
    },

    _update: function () {
      var that = this;
      _.defer(function () {
        that.reset();
      });
    },

    reset: function (models, options) {
      models = this._filter(this.delegate.models);
      //return Backbone.Collection.prototype.reset.apply(this, [models].concat(Array.prototype.slice.call(arguments, 1)));

      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({}, options));
      if (!options.silent) this.trigger("reset", this, options);
      return models;
    },

    // Add a model, or list of models to the set. Pass **silent** to avoid
    // firing the `add` event for every new model.
    add: function(models, options) {
      var i, args, length, model, existing, needsSort;
      var at = options && options.at;
      var sort = ((options && options.sort) == null ? true : options.sort);
      models = _.isArray(models) ? models.slice() : [models];

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = models.length - 1; i >= 0; i--) {
        if(!(model = this._prepareModel(models[i], options))) {
          this.trigger("error", this, models[i], options);
          models.splice(i, 1);
          continue;
        }
        models[i] = model;

        existing = model.id != null && this._byId.hasOwnProperty(model.id) && this._byId[model.id];
        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing || this._byCid.hasOwnProperty(model.cid) && this._byCid[model.cid]) {
          if (options && options.merge && existing) {
            existing.set(model.attributes, options);
            needsSort = sort;
          }
          models.splice(i, 1);
          continue;
        }

        // Listen to added models' events, and index models for lookup by
        // `id` and by `cid`.
        model.on("all", this._onModelEvent, this);
        this._byCid[model.cid] = model;
        if (model.id != null) this._byId[model.id] = model;
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (models.length) needsSort = sort;
      this.length += models.length;
      args = [at != null ? at : this.models.length, 0];
      push.apply(args, models);
      splice.apply(this.models, args);

      // Sort the collection if appropriate.
      if (needsSort && this.comparator && at == null) this.sort({silent: true});

      if (options && options.silent) return this;

      // Trigger `add` events.
      var at = 0,
          previousIndex;
      while (model = models.shift()) {

        if (options.previousModels) {
          previousIndex = _.indexOf(options.previousModels, model);
          if (previousIndex >= 0) {
            options.previousModels.splice(previousIndex, 1);
          }
        }
        if (!options.previousModels || previousIndex < 0) {
          options = _.extend({}, options, {at: at});
          model.trigger("add", model, this, options);
        }
        at++;
      }
      if (options.previousModels) {
        while (model = options.previousModels.shift()) {
          model.trigger("remove", model, this, options);
          this._onModelEvent("remove", model, this, options);
        }
      }

      return this;
    },

    setFilter: function (filter) {
      this._filter = filter;
      this._update();
    },

    _prepareModel: function (model) {
      return model;
    },

    cutoff: function () {
      return this.models.length !== this.delegate.models.length;
    }

  }));

});
